﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { eUvMode } from '../enums';
import { IUvMapFeature } from '../kb3d-models';
import { KbVector } from '../primitives/kb-vector';
import { Token } from '../token';
import { ALL_GEOMETRY, Feature } from './feature';

@Kb3dModel({
    token: Token.UvMapFeature,
})
export class UvMapFeature extends Feature implements IUvMapFeature {
    static _affects = new Set(ALL_GEOMETRY);
    static _affectedBy = new Set(ALL_GEOMETRY);

    center: KbVector;
    projectionAxis: KbVector;
    worldPosition = this._parent?.position;
    angle: number;
    scale: KbVector;
    uTile: number;
    vTile: number;
    uOffset: number;
    vOffset: number;
    mode: eUvMode;
    _previewMaterialVisible: boolean;
    _showMaterial: boolean;
}
